window.VgMap = {
	city: 'Москва',
	myMap: null,
	clusterer: null,
	pointCollection: null,
	id: '',
	placeMark: {
		layout: '',
		preset: 'islands#icon',
		iconColor: '#8B0000',
		iconColorActive: '#228B22'
	},
	controls: [
		'geolocationControl',
		'searchControl',
		'typeSelector',
		'fullscreenControl',
		'scrollZoom'
	],

	init: function ($map) {
		let id = $map.attr('id'),
			lat = $map.data('lat') || false,
			lon = $map.data('lon') || false,
			points = $map.data('points') || [],
			reset = $map.data('reset') || false,
			controls = $map.data('controls') || [],
			cities = $map.data('cities') || {},
			cluster = $map.data('cluster') || false,
			event = $map.data('event') || false,
			zoom = $map.data('zoom') || 16;

		VgMap.setSizeMap($map);

		for (let i = 0; i < cities.length; i++) {
			for (let n = 0; n < cities[i].stores.length; n++) {
				points.push(cities[i].stores[n]);
			}
		}

		if (points.length && (!lat || !lon)) {
			for (let i = 1; i <= points.length; i++) {
				if (('lat' in points[i - 1]) && ('lon' in points[i - 1])) {
					if (i === 1) {
						lat = points[i - 1].lat;
						lon = points[i - 1].lon;
					}
				}
			}
		}

		if (lat && lon) {
			ymaps.ready(init);

			function init() {
				/* Рисуем карту */
				let myMap = VgMap.setMap(id, [lat, lon], zoom);

				/* Отключаем не нужное. Передаем в массив (дата аттрибут), то что не нужно отключать, если нужно отключить всё оставляем пустым */
				VgMap.disabled(myMap, controls);

				/* Добавляем метку */
				if (points.length) {
					if (!cluster) {
						let objects = getObjects(points);
						VgMap.pointCollection = new ymaps.GeoObjectCollection();

						for (let i in objects) {
							VgMap.pointCollection.add(objects[i]);
						}

						VgMap.myMap.geoObjects.add(VgMap.pointCollection);
						VgMap.myMap.setBounds(myMap.geoObjects.getBounds(), {
							checkZoomRange: true,
							zoomMargin: 40
						});
					} else {
						VgMap.clusterer = new ymaps.Clusterer({
							clusterIconLayout: 'default#pieChart',
							clusterIconPieChartRadius: 25,
							clusterIconPieChartCoreRadius: 15,
							clusterIconPieChartStrokeWidth: 3,
							hasBalloon: false,
							clusterHideIconOnBalloonOpen: false,
							geoObjectHideIconOnBalloonOpen: false,
						});

						VgMap.clusterer.add(getObjects(points));
						myMap.geoObjects.add(VgMap.clusterer);
					}
				} else {
					VgMap.setPlaceMark(myMap, [lat, lon]);
				}

				function getObjects(points) {
					let objects = [];

					for (let i in points) {
						objects[i] = VgMap.setPlaceMark(myMap, points[i], true)
					}

					return objects;
				}

				if (window.innerWidth < 1000) {
					myMap.behaviors.get('drag').disable();
				}

				myMap.geoObjects.events.add('click', function (e) {
					if (event && event === 'selectStore') {
						VgMap.selectStore(e, myMap)
					}

					if (event && event === 'clickStore') {
						VgMap.clickStore(e, myMap)
					}
				});

				if (event && event === 'selectStore') {
					VgMap.selectStore(null, myMap)
				}

				if (event && event === 'clickStore') {
					VgMap.clickStore(null, myMap)
				}
			}
		} else {
			console.error('Coordinates not found');
			return false;
		}
	},

	setMap: function (id, coordinates, zoom) {
		return new ymaps.Map(id, {
			center: coordinates,
			zoom: zoom,
			controls: ['smallMapDefaultSet'],
		}, {
			searchControlProvider: 'yandex#search',
			suppressMapOpenBlock: true,
		});
	},

	setPlaceMark: function (map, point, obj = false) {
		let placeMark, marker;

		if (VgMap.placeMark.layout) {
			let circleLayout = ymaps.templateLayoutFactory.createClass(VgMap.placeMark.layout);

			marker = {
				iconLayout: circleLayout
			}
		} else {
			marker = {
				preset: VgMap.placeMark.preset,
				iconColor: VgMap.placeMark.iconColor
			}
		}

		if (obj) {
			placeMark = new ymaps.Placemark([point.lat, point.lon], {}, marker);
		} else {
			placeMark = new ymaps.Placemark(
				map.getCenter(), {}, marker
			);

			map.geoObjects.add(placeMark);
		}

		return placeMark;
	},

	disabled: function (map, items = []) {
		if (items.length > 0) {
			$.each(items, function (i, val) {
				if (VgMap.controls.indexOf(val) > -1) {
					delete VgMap.controls[i];
				}
			});
		}

		$.each(VgMap.controls, function (i, val) {
			if (val !== 'undefined') {
				map.controls.remove(val);
			}
		});
	},

	setSizeMap: function ($map) {
		if ($map.height() === 0) {
			let hParent = $map.parent().height();

			if (hParent === 0) {
				hParent = $map.parent().parent().height();

				$map.css('height', hParent);
			}
		}

		return false;
	},

	getGeoCoords: function (value, callback) {
		ymaps.geocode(value, {
			results: 1
		}).then(function (res) {
			let firstGeoObject = res.geoObjects.get(0),
				coords = firstGeoObject.geometry.getCoordinates();

			if (typeof callback === "function") callback(coords);
		});
	},

	choiceInMap: function () {
		let $locationMapCity = $('#location-map-city'),
			$locationMapStreet = $('#location-map-street'),
			$addLocation = $("[data-toggle=add-location]"),
			$addLocationNotFound = $(document).find('#addLocationNotFound'),
			$locationYaMap = $('#location-ya-map');

		// Размеры карты
		VgMap.setSizeMap($locationYaMap);

		ymaps.ready(searchApi);

		/**
		 * Подключаем яндекс карты
		 * **/
		function searchApi() {
			let myMap, myPlaceMark, suggestView;

			// Выбранный город
			let locality = {zoom: 15},
				city_id = parseInt($locationMapCity.val());

			locality.city = getCity(city_id);

			VgMap.getGeoCoords(locality.city, function (coords) {
				locality.coordinates = coords;
				drawMap(locality);
			});

			$locationMapCity.change(function () {
				let city_id = parseInt($(this).val());
				locality.city = getCity(city_id);

				// Если были ошибки скрываем
				if ($addLocationNotFound.length) {
					$addLocationNotFound.slideUp();
				}

				$locationMapStreet.val('');
				$addLocation.attr('disabled', true);

				VgMap.getGeoCoords(locality.city, function (coords) {
					locality.coordinates = coords;
					drawMap(locality, false);
				});
			});

			function drawMap(locality, isNewMap = true) {
				if (isNewMap) {
					myMap = new ymaps.Map($locationYaMap.attr('id'), {
						center: locality.coordinates,
						zoom: locality.zoom,
						controls: ['zoomControl', 'fullscreenControl']
					}, {searchControlProvider: 'yandex#search'});
				} else {
					myMap.setCenter(locality.coordinates, locality.zoom);
				}

				// Кликнули по карте
				myMap.events.add('click', function (e) {
					let coords = e.get('coords');

					setPlaceMark(coords);
					setAddress(coords);
				});

				myMap.geoObjects.events.add('click', function (e) {
					let object = e.get('target');
					myMap.geoObjects.remove(object);
					myPlaceMark = null;
				});

				// Если вставили название улицы и нажали энтер
				$locationMapStreet.keyup(function (e) {
					if (e.keyCode === 13) {
						VgMap.getGeoCoords(locality.city + ', ' + document.getElementById($locationMapStreet.attr('id')).value, function (coords) {
							setPlaceMark(coords);
							setAddress(coords);
						});

						return false;
					}
				});

				if (isNewMap) {
					// если начали вводить название улицы, то выводим подсказки
					suggestView = new ymaps.SuggestView($locationMapStreet.attr('id'), {
						provider: {
							suggest: (function (request) {
								return ymaps.suggest(locality.city + ", " + request)
							})
						}
					});

					suggestView.events.add('select', function (e) {
						VgMap.getGeoCoords(locality.city + ', ' + e.get('item').value, function (coords) {
							setPlaceMark(coords);
							setAddress(coords, {}, e.get('item').value);
						});

						e.preventDefault();
						return false;
					});
				}
			}

			function createPlaceMark(coords) {
				return new ymaps.Placemark(coords, {
					iconCaption: 'Подождите...'
				}, {
					preset: VgMap.placeMark.preset,
					iconColor: VgMap.placeMark.iconColor,
					draggable: true,
				});
			}

			function setPlaceMark(coords) {
				if (myPlaceMark) {
					myPlaceMark.geometry.setCoordinates(coords);
				} else {
					myPlaceMark = createPlaceMark(coords);
					myMap.geoObjects.add(myPlaceMark);
				}
			}

			function setAddress(coords, results = {}, addressLine = '') {
				myPlaceMark.properties.set('iconCaption', 'Подождите...');

				// Если были ошибки скрываем
				if ($addLocationNotFound.length) {
					$addLocationNotFound.slideUp();
				}

				if (addressLine) {
					myPlaceMark.properties.set({
						iconCaption: addressLine,
						balloonContent: addressLine
					});

					getGeoData(coords, results)
				} else {
					getGeoData(coords, results, true);
				}

				myMap.setCenter(coords, 17);
			}

			function getGeoData(coords, results, isPlaceMark = false) {
				ymaps.geocode(coords, results).then(function (res) {
					let firstGeoObject = res.geoObjects.get(0);

					if (isPlaceMark) {
						myPlaceMark.properties.set({
							iconCaption: [
								firstGeoObject.getLocalities().length ? firstGeoObject.getLocalities() : firstGeoObject.getAdministrativeAreas(),
								firstGeoObject.getThoroughfare() || firstGeoObject.getPremiseNumber()
							].filter(Boolean).join(', '),
							balloonContent: firstGeoObject.getAddressLine()
						});

						$locationMapStreet.val(firstGeoObject.getAddressLine());
					}

					let fullAddress = {
						city: firstGeoObject.getLocalities().join(''),
						street: firstGeoObject.getThoroughfare(),
						house: firstGeoObject.getPremiseNumber(),
						address: firstGeoObject.getAddressLine(),
						entrance: '',
					}

					let $addLocation = $(document).find('[data-toggle="add-location"]');
					if (fullAddress.city && fullAddress.street && fullAddress.house) {
						$('#location-map-street-hidden').val(fullAddress.street + ', ' + fullAddress.house);
						$('#location-map-full-address').val(fullAddress.address);

						if (locality.city !== fullAddress.city) {
							if ($addLocationNotFound.length) {
								$addLocationNotFound.slideDown();

								if ($addLocation.length) {
									$addLocation.attr('disabled', true);
								}
							}
						} else {
							if ($addLocation.length) {
								$addLocation.removeAttr('disabled');
							}
						}
					} else {
						$locationMapStreet.val(fullAddress.address);
						$addLocation.attr('disabled', true);
					}
				});
			}
		}

		function getCity(id) {
			return App.cities.filter(obj => obj.id === id).map(obj => obj.title).join('');
		}
	},

	selectStore: function (event = null, myMap) {
		if (event) {
			let target = event.get('target'),
				coordinates = target.geometry._coordinates;

			myMap.setCenter(coordinates, 16);

			let $addresses = $('[data-toggle-store]').find('option');
			$addresses.attr('selected', false);

			for (let i = 0; i < $addresses.length; i++) {
				let address = $addresses[i].dataset.coordinates;

				if (address === coordinates.join(',')) {
					$addresses[i].setAttribute('selected', 'selected');
				}
			}
		} else {
			let $stores = $('[data-toggle-store]');

			if ($stores.length) {
				$stores.change(function () {
					let address = this.options[this.selectedIndex].dataset.coordinates;

					if (address) {
						let p = address.split(',');

						myMap.setCenter(p, 16);
					}
				});
			}
		}
	},

	clickStore: function (event = null, myMap) {
		if (event) {
			let target = event.get('target'),
				type = event.get('type'),
				coordinates = target.geometry._coordinates;

			if (type === 'click') {
				target.options.set('iconColor', VgMap.placeMark.iconColorActive);
			}

			myMap.setCenter(coordinates, 16);

			let $addresses = $('[data-all-store]').find('a');
			$addresses.removeClass('active');

			for (let i = 0; i < $addresses.length; i++) {
				let address = $addresses[i].dataset.coordinates;

				if (address === coordinates.join(',')) {
					$addresses[i].classList.add('active');

					if (window.innerWidth > 1199) {
						$([document.documentElement, document.body]).animate({
							scrollTop: $($addresses[i]).offset().top - $($addresses[i]).height() - 60
						}, 0);
					}
				}
			}
		} else {
			$('[data-toggle="map-stores"]').click(function () {
				let address = $(this).data('coordinates');

				$(this).closest('.vg-stores-list').find('a.active').removeClass('active');
				$(this).addClass('active');

				if (address) {
					let p = address.split(',');

					myMap.setCenter(p, 17);

					if (window.innerWidth > 1199) {
						document.getElementById('yaMapStores').scrollIntoView();
					}
				}

				return false;
			});
		}
	},

	getUserLocation: function () {
		ymaps.ready(init);

		function init() {
			let geolocation = ymaps.geolocation;

			geolocation.get({
				provider: 'yandex',
				autoReverseGeocode: true
			}).then(function (result) {
				let data = result.geoObjects.get(0).properties.get('metaDataProperty');
				VgMap.city = data.GeocoderMetaData.Address.Components[4]['name'];

				Cookies.set('city', VgMap.city);
			});
		}
	}
};

$(document).ready(function () {
	let $map = $('[data-map]');

	if ($map.length) {
		$map.each(function () {
			VgMap.init($(this));
		});
	}
});